import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "collapse show" }
const _hoisted_6 = { class: "card-body border-top p-9" }
const _hoisted_7 = { class: "row mb-6" }
const _hoisted_8 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_9 = { class: "col-lg-8 fv-row" }
const _hoisted_10 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_11 = { class: "row mb-6" }
const _hoisted_12 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_13 = { class: "col-lg-8 fv-row" }
const _hoisted_14 = { class: "fv-plugins-message-container" }
const _hoisted_15 = { class: "fv-help-block" }
const _hoisted_16 = { class: "row mb-6" }
const _hoisted_17 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_18 = { class: "col-lg-8 fv-row" }
const _hoisted_19 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_20 = { class: "row mb-6" }
const _hoisted_21 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_22 = { class: "col-lg-8 fv-row" }
const _hoisted_23 = { class: "fv-plugins-message-container" }
const _hoisted_24 = { class: "fv-help-block" }
const _hoisted_25 = { class: "row mb-6" }
const _hoisted_26 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_27 = { class: "col-lg-8 fv-row" }
const _hoisted_28 = { class: "row mb-6" }
const _hoisted_29 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_30 = { class: "col-lg-8 fv-row" }
const _hoisted_31 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-10" }, null, -1)
const _hoisted_34 = { class: "row mb-5" }
const _hoisted_35 = { class: "col-md-6 fv-row" }
const _hoisted_36 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_37 = ["title"]
const _hoisted_38 = { class: "col-lg-6" }
const _hoisted_39 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_40 = { class: "fv-help-block" }
const _hoisted_41 = { class: "col-md-6 fv-row" }
const _hoisted_42 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_43 = ["title"]
const _hoisted_44 = { class: "col-lg-6 fv-row" }
const _hoisted_45 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_46 = { class: "fv-help-block" }
const _hoisted_47 = { class: "row mb-5" }
const _hoisted_48 = { class: "col-md-6 fv-row" }
const _hoisted_49 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_50 = ["title"]
const _hoisted_51 = { class: "col-lg-6 fv-row" }
const _hoisted_52 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_53 = { class: "fv-help-block" }
const _hoisted_54 = { class: "col-md-6 fv-row" }
const _hoisted_55 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_56 = ["title"]
const _hoisted_57 = { class: "col-lg-6 fv-row" }
const _hoisted_58 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_59 = { class: "fv-help-block" }
const _hoisted_60 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_61 = {
  key: 0,
  type: "submit",
  id: "kt_account_profile_details_submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_62 = { class: "indicator-label" }
const _hoisted_63 = { class: "indicator-progress" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_65 = {
  key: 1,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_66 = {
  class: "card-header border-0",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_appraiser_create_banks",
  "aria-expanded": "true",
  "aria-controls": "kt_appraiser_create_banks"
}
const _hoisted_67 = { class: "card-title m-0" }
const _hoisted_68 = { class: "fw-bolder m-0" }
const _hoisted_69 = { class: "collapse show" }
const _hoisted_70 = { class: "table-wrapper" }
const _hoisted_71 = { class: "custom-table" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "main-col",
      colSpan: "4"
    }, "متوسط"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "main-col",
      colSpan: "4"
    }, "جيد"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "main-col",
      colSpan: "4"
    }, "جيد جدا")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "sticky" }, "size"),
    /*#__PURE__*/_createElementVNode("th", null, "value"),
    /*#__PURE__*/_createElementVNode("th", null, "price Per Meter"),
    /*#__PURE__*/_createElementVNode("th", null, "Action"),
    /*#__PURE__*/_createElementVNode("th", null, "increasePercentage"),
    /*#__PURE__*/_createElementVNode("th", null, "value"),
    /*#__PURE__*/_createElementVNode("th", null, "price Per Meter"),
    /*#__PURE__*/_createElementVNode("th", null, "Action"),
    /*#__PURE__*/_createElementVNode("th", null, "increasePercentage"),
    /*#__PURE__*/_createElementVNode("th", null, "value"),
    /*#__PURE__*/_createElementVNode("th", null, "price Per Meter"),
    /*#__PURE__*/_createElementVNode("th", null, "Action")
  ])
], -1)
const _hoisted_73 = ["onClick"]
const _hoisted_74 = { class: "svg-icon svg-icon-3" }
const _hoisted_75 = { style: {"background-color":"#ffeb3b"} }
const _hoisted_76 = ["onClick"]
const _hoisted_77 = { class: "svg-icon svg-icon-3" }
const _hoisted_78 = { style: {"background-color":"#ffeb3b"} }
const _hoisted_79 = ["onClick"]
const _hoisted_80 = { class: "svg-icon svg-icon-3" }
const _hoisted_81 = {
  key: 2,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_82 = {
  class: "card-header border-0",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_appraiser_create_banks",
  "aria-expanded": "true",
  "aria-controls": "kt_appraiser_create_banks"
}
const _hoisted_83 = { class: "card-title m-0" }
const _hoisted_84 = { class: "fw-bolder m-0" }
const _hoisted_85 = { class: "collapse show" }
const _hoisted_86 = { class: "table-wrapper" }
const _hoisted_87 = { class: "custom-table" }
const _hoisted_88 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "main-col",
      colSpan: "4"
    }, "0-10"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "main-col",
      colSpan: "4"
    }, "11-20"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "main-col",
      colSpan: "4"
    }, "21-30")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "sticky" }, "size"),
    /*#__PURE__*/_createElementVNode("th", null, "value"),
    /*#__PURE__*/_createElementVNode("th", null, "price Per Meter"),
    /*#__PURE__*/_createElementVNode("th", null, "Action"),
    /*#__PURE__*/_createElementVNode("th", null, "decreasedPercentage"),
    /*#__PURE__*/_createElementVNode("th", null, "value"),
    /*#__PURE__*/_createElementVNode("th", null, "price Per Meter"),
    /*#__PURE__*/_createElementVNode("th", null, "Action"),
    /*#__PURE__*/_createElementVNode("th", null, "decreasedPercentage"),
    /*#__PURE__*/_createElementVNode("th", null, "value"),
    /*#__PURE__*/_createElementVNode("th", null, "price Per Meter"),
    /*#__PURE__*/_createElementVNode("th", null, "Action")
  ])
], -1)
const _hoisted_89 = ["onClick"]
const _hoisted_90 = { class: "svg-icon svg-icon-3" }
const _hoisted_91 = { style: {"background-color":"#ffeb3b"} }
const _hoisted_92 = ["onClick"]
const _hoisted_93 = { class: "svg-icon svg-icon-3" }
const _hoisted_94 = { style: {"background-color":"#ffeb3b"} }
const _hoisted_95 = ["onClick"]
const _hoisted_96 = { class: "svg-icon svg-icon-3" }
const _hoisted_97 = {
  key: 3,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_98 = {
  class: "card-header border-0",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_shop_rent_config",
  "aria-expanded": "true",
  "aria-controls": "kt_shop_rent_config"
}
const _hoisted_99 = { class: "card-title m-0" }
const _hoisted_100 = { class: "fw-bolder m-0" }
const _hoisted_101 = {
  id: "kt_shop_rent_config",
  class: "collapse show"
}
const _hoisted_102 = { class: "card-body border-top p-9" }
const _hoisted_103 = { class: "row mb-6" }
const _hoisted_104 = { class: "col fv-row" }
const _hoisted_105 = { class: "py-0" }
const _hoisted_106 = { class: "py-3 d-flex flex-stack flex-wrap" }
const _hoisted_107 = ["href", "aria-controls"]
const _hoisted_108 = { class: "me-3 rotate-90" }
const _hoisted_109 = { class: "svg-icon svg-icon-3" }
const _hoisted_110 = { class: "me-3" }
const _hoisted_111 = { class: "d-flex align-items-center" }
const _hoisted_112 = { class: "text-gray-800 fw-bolder" }
const _hoisted_113 = ["id"]
const _hoisted_114 = { class: "d-flex flex-wrap py-5" }
const _hoisted_115 = { class: "flex-equal me-5" }
const _hoisted_116 = { class: "table table-flush fw-bold gy-1" }
const _hoisted_117 = { class: "text-muted min-w-125px w-125px" }
const _hoisted_118 = ["placeholder", "onUpdate:modelValue"]
const _hoisted_119 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed" }, null, -1)
const _hoisted_120 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_121 = { class: "indicator-label" }
const _hoisted_122 = { class: "indicator-progress" }
const _hoisted_123 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_124 = {
  key: 4,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_125 = {
  class: "card-header border-0",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_shop_rent_config",
  "aria-expanded": "true",
  "aria-controls": "kt_shop_rent_config"
}
const _hoisted_126 = { class: "card-title m-0" }
const _hoisted_127 = { class: "fw-bolder m-0" }
const _hoisted_128 = {
  id: "kt_basement_rent_config",
  class: "collapse show"
}
const _hoisted_129 = { class: "card-body border-top p-9" }
const _hoisted_130 = { class: "row mb-6" }
const _hoisted_131 = { class: "col fv-row" }
const _hoisted_132 = { class: "py-0" }
const _hoisted_133 = { class: "py-3 d-flex flex-stack flex-wrap" }
const _hoisted_134 = ["href", "aria-controls"]
const _hoisted_135 = { class: "me-3 rotate-90" }
const _hoisted_136 = { class: "svg-icon svg-icon-3" }
const _hoisted_137 = { class: "me-3" }
const _hoisted_138 = { class: "d-flex align-items-center" }
const _hoisted_139 = { class: "text-gray-800 fw-bolder" }
const _hoisted_140 = ["id"]
const _hoisted_141 = { class: "d-flex flex-wrap py-5" }
const _hoisted_142 = { class: "flex-equal me-5" }
const _hoisted_143 = { class: "table table-flush fw-bold gy-1" }
const _hoisted_144 = { class: "text-muted min-w-125px w-125px" }
const _hoisted_145 = ["placeholder", "onUpdate:modelValue"]
const _hoisted_146 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed" }, null, -1)
const _hoisted_147 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_148 = { class: "indicator-label" }
const _hoisted_149 = { class: "indicator-progress" }
const _hoisted_150 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_151 = {
  class: "modal fade",
  tabindex: "-1",
  id: "kt_modal_1"
}
const _hoisted_152 = { class: "modal-dialog" }
const _hoisted_153 = { class: "modal-content" }
const _hoisted_154 = { class: "modal-header" }
const _hoisted_155 = { class: "modal-title" }
const _hoisted_156 = /*#__PURE__*/_createElementVNode("div", {
  class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2x" })
], -1)
const _hoisted_157 = { class: "modal-body" }
const _hoisted_158 = { class: "d-flex flex-column mb-5 fv-row" }
const _hoisted_159 = { class: "fs-5 fw-bold mb-2 required" }
const _hoisted_160 = { class: "fv-plugins-message-container" }
const _hoisted_161 = { class: "fv-help-block" }
const _hoisted_162 = {
  key: 0,
  class: "d-flex flex-column mb-5 fv-row"
}
const _hoisted_163 = { class: "fs-5 fw-bold mb-2 required" }
const _hoisted_164 = { class: "fv-plugins-message-container" }
const _hoisted_165 = { class: "fv-help-block" }
const _hoisted_166 = {
  key: 1,
  class: "d-flex flex-column mb-5 fv-row"
}
const _hoisted_167 = { class: "fs-5 fw-bold mb-2 required" }
const _hoisted_168 = { class: "fv-plugins-message-container" }
const _hoisted_169 = { class: "fv-help-block" }
const _hoisted_170 = { class: "modal-footer" }
const _hoisted_171 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-light",
  "data-bs-dismiss": "modal"
}, " Close ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.can('read', 'instant-rent-estimator'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.translate('updateIreAreaValue')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Form, {
              class: "form",
              onSubmit: _ctx.onSubmitUpdate,
              "validation-schema": _ctx.areaSchema
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("label", _hoisted_8, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.translate('areas')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("label", _hoisted_10, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.area.areaName), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.translate('baseValue')), 1),
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_component_Field, {
                        type: "number",
                        name: "baseValue",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: _ctx.translate('baseValue'),
                        modelValue: _ctx.baseValue,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.baseValue) = $event)),
                        onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.fillPercentages(_ctx.baseValue)))
                      }, null, 8, ["placeholder", "modelValue"]),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          _createVNode(_component_ErrorMessage, { name: "baseValue" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.translate('isSeaView')) + ": ", 1),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("label", _hoisted_19, [
                        _createVNode(_component_Field, {
                          class: "form-check-input",
                          name: "isSeaView",
                          type: "checkbox",
                          modelValue: _ctx.area.isSeaView,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.area.isSeaView) = $event)),
                          value: true,
                          checked: "checked"
                        }, null, 8, ["modelValue"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.translate('sort')), 1),
                    _createElementVNode("div", _hoisted_22, [
                      _createVNode(_component_Field, {
                        type: "number",
                        modelValue: _ctx.area.sort,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.area.sort) = $event)),
                        name: "sort",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: _ctx.translate('sort')
                      }, null, 8, ["modelValue", "placeholder"]),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _createVNode(_component_ErrorMessage, { name: "sort" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.translate('customUpdatedAt')) + ": ", 1),
                    _createElementVNode("div", _hoisted_27, [
                      _createVNode(_component_Field, {
                        type: "date",
                        name: "customUpdatedAt",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-solid",
                        modelValue: _ctx.area.customUpdatedAt,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.area.customUpdatedAt) = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.translate('editPercentages')) + ": ", 1),
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("label", _hoisted_31, [
                        _createVNode(_component_Field, {
                          class: "form-check-input",
                          name: "editPercentages",
                          type: "checkbox",
                          modelValue: _ctx.area.editPercentages,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.area.editPercentages) = $event)),
                          value: true,
                          checked: "checked",
                          disabled: _ctx.disabledEditPercentages
                        }, null, 8, ["modelValue", "disabled"])
                      ])
                    ])
                  ]),
                  (_ctx.area.editPercentages)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                        _hoisted_33,
                        _createElementVNode("div", _hoisted_34, [
                          _createElementVNode("div", _hoisted_35, [
                            _createElementVNode("label", _hoisted_36, [
                              _createTextVNode(_toDisplayString(_ctx.translate('firstIncreasePercentage')) + " ", 1),
                              _createElementVNode("i", {
                                class: "fas fa-exclamation-circle ms-1 fs-7 bg-hover-white",
                                "data-bs-toggle": "tooltip",
                                title: _ctx.translate('firstIncreasePercentageToolTip')
                              }, null, 8, _hoisted_37)
                            ]),
                            _createElementVNode("div", _hoisted_38, [
                              _createVNode(_component_Field, {
                                type: "number",
                                name: "firstIncreasePercentage",
                                autocomplete: "off",
                                class: "form-control form-control-lg form-control-white",
                                placeholder: _ctx.translate('firstIncreasePercentage'),
                                modelValue: _ctx.area.firstIncreasePercentage,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.area.firstIncreasePercentage) = $event))
                              }, null, 8, ["placeholder", "modelValue"]),
                              (_ctx.area.editPercentages)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                    _createElementVNode("div", _hoisted_40, [
                                      _createVNode(_component_ErrorMessage, { name: "firstIncreasePercentage" })
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_41, [
                            _createElementVNode("label", _hoisted_42, [
                              _createTextVNode(_toDisplayString(_ctx.translate('secondIncreasePercentage')) + " ", 1),
                              _createElementVNode("i", {
                                class: "fas fa-exclamation-circle ms-1 fs-7 bg-hover-white",
                                "data-bs-toggle": "tooltip",
                                title: _ctx.translate('secondIncreasePercentageToolTip')
                              }, null, 8, _hoisted_43)
                            ]),
                            _createElementVNode("div", _hoisted_44, [
                              _createVNode(_component_Field, {
                                type: "number",
                                name: "secondIncreasePercentage",
                                autocomplete: "off",
                                class: "form-control form-control-lg form-control-white",
                                placeholder: _ctx.translate('secondIncreasePercentage'),
                                modelValue: _ctx.area.secondIncreasePercentage,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.area.secondIncreasePercentage) = $event))
                              }, null, 8, ["placeholder", "modelValue"]),
                              (_ctx.area.editPercentages)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                    _createElementVNode("div", _hoisted_46, [
                                      _createVNode(_component_ErrorMessage, { name: "secondIncreasePercentage" })
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_47, [
                          _createElementVNode("div", _hoisted_48, [
                            _createElementVNode("label", _hoisted_49, [
                              _createTextVNode(_toDisplayString(_ctx.translate('firstDecreasedPercentage')) + " ", 1),
                              _createElementVNode("i", {
                                class: "fas fa-exclamation-circle ms-1 fs-7 bg-hover-white",
                                "data-bs-toggle": "tooltip",
                                title: _ctx.translate('firstDecreasedPercentageToolTip')
                              }, null, 8, _hoisted_50)
                            ]),
                            _createElementVNode("div", _hoisted_51, [
                              _createVNode(_component_Field, {
                                type: "number",
                                name: "firstDecreasedPercentage",
                                autocomplete: "off",
                                class: "form-control form-control-lg form-control-white",
                                placeholder: _ctx.translate('firstDecreasedPercentage'),
                                modelValue: _ctx.area.firstDecreasedPercentage,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.area.firstDecreasedPercentage) = $event))
                              }, null, 8, ["placeholder", "modelValue"]),
                              (_ctx.area.editPercentages)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                    _createElementVNode("div", _hoisted_53, [
                                      _createVNode(_component_ErrorMessage, { name: "firstDecreasedPercentage" })
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_54, [
                            _createElementVNode("label", _hoisted_55, [
                              _createTextVNode(_toDisplayString(_ctx.translate('secondDecreasedPercentage')) + " ", 1),
                              _createElementVNode("i", {
                                class: "fas fa-exclamation-circle ms-1 fs-7 bg-hover-white",
                                "data-bs-toggle": "tooltip",
                                title: _ctx.translate('secondDecreasedPercentageToolTip')
                              }, null, 8, _hoisted_56)
                            ]),
                            _createElementVNode("div", _hoisted_57, [
                              _createVNode(_component_Field, {
                                type: "number",
                                name: "secondDecreasedPercentage",
                                autocomplete: "off",
                                class: "form-control form-control-lg form-control-white",
                                placeholder: _ctx.translate('secondDecreasedPercentage'),
                                modelValue: _ctx.area.secondDecreasedPercentage,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.area.secondDecreasedPercentage) = $event))
                              }, null, 8, ["placeholder", "modelValue"]),
                              (_ctx.area.editPercentages)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                                    _createElementVNode("div", _hoisted_59, [
                                      _createVNode(_component_ErrorMessage, { name: "secondDecreasedPercentage" })
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_60, [
                  _createElementVNode("button", {
                    type: "reset",
                    class: "btn btn-white btn-active-light-primary me-2",
                    onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                  }, _toDisplayString(_ctx.translate('discard')), 1),
                  (_ctx.can('update', 'instant-rent-estimator'))
                    ? (_openBlock(), _createElementBlock("button", _hoisted_61, [
                        _createElementVNode("span", _hoisted_62, _toDisplayString(_ctx.translate('saveChanges')), 1),
                        _createElementVNode("span", _hoisted_63, [
                          _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                          _hoisted_64
                        ])
                      ], 512))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["onSubmit", "validation-schema"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.can('update', 'instant-rent-estimator'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
          _createElementVNode("div", _hoisted_66, [
            _createElementVNode("div", _hoisted_67, [
              _createElementVNode("h3", _hoisted_68, _toDisplayString(_ctx.translate('sizeQualityConfig')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_69, [
            _createElementVNode("div", _hoisted_70, [
              _createElementVNode("table", _hoisted_71, [
                _hoisted_72,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sizeQualityConfig['1'], (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: item.id
                    }, [
                      _createElementVNode("td", null, _toDisplayString(item.sizeTitle), 1),
                      _createElementVNode("td", null, _toDisplayString(item.value), 1),
                      _createElementVNode("td", null, _toDisplayString(item.priceRentalPerMeter), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("a", {
                          href: "#",
                          class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1",
                          type: "button",
                          "data-bs-toggle": "modal",
                          "data-bs-target": "#kt_modal_1",
                          onClick: _withModifiers(($event: any) => (_ctx.sendInfo(_ctx.sizeQualityConfig['1'][index], 1)), ["prevent"])
                        }, [
                          _createElementVNode("span", _hoisted_74, [
                            _createVNode(_component_inline_svg, { src: "/media/icons/duotune/art/art005.svg" })
                          ])
                        ], 8, _hoisted_73)
                      ]),
                      _createElementVNode("td", _hoisted_75, _toDisplayString(_ctx.sizeQualityConfig['2'][index].increasePercentage + ' %'), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.sizeQualityConfig['2'][index].value), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.sizeQualityConfig['2'][index].priceRentalPerMeter), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("a", {
                          href: "#",
                          class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1",
                          type: "button",
                          "data-bs-toggle": "modal",
                          "data-bs-target": "#kt_modal_1",
                          onClick: _withModifiers(($event: any) => (_ctx.sendInfo(_ctx.sizeQualityConfig['2'][index], 1)), ["prevent"])
                        }, [
                          _createElementVNode("span", _hoisted_77, [
                            _createVNode(_component_inline_svg, { src: "/media/icons/duotune/art/art005.svg" })
                          ])
                        ], 8, _hoisted_76)
                      ]),
                      _createElementVNode("td", _hoisted_78, _toDisplayString(_ctx.sizeQualityConfig['3'][index].increasePercentage + ' %'), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.sizeQualityConfig['3'][index].value), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.sizeQualityConfig['3'][index].priceRentalPerMeter), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("a", {
                          href: "#",
                          class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1",
                          type: "button",
                          "data-bs-toggle": "modal",
                          "data-bs-target": "#kt_modal_1",
                          onClick: _withModifiers(($event: any) => (_ctx.sendInfo(_ctx.sizeQualityConfig['3'][index], 1)), ["prevent"])
                        }, [
                          _createElementVNode("span", _hoisted_80, [
                            _createVNode(_component_inline_svg, { src: "/media/icons/duotune/art/art005.svg" })
                          ])
                        ], 8, _hoisted_79)
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.can('update', 'instant-rent-estimator'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
          _createElementVNode("div", _hoisted_82, [
            _createElementVNode("div", _hoisted_83, [
              _createElementVNode("h3", _hoisted_84, _toDisplayString(_ctx.translate('PropertyAgeConfig')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_85, [
            _createElementVNode("div", _hoisted_86, [
              _createElementVNode("table", _hoisted_87, [
                _hoisted_88,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.propertyAgeConfig['1'], (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: item.id
                    }, [
                      _createElementVNode("td", null, _toDisplayString(item.sizeTitle), 1),
                      _createElementVNode("td", null, _toDisplayString(item.value), 1),
                      _createElementVNode("td", null, _toDisplayString(item.priceRentalPerMeter), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("a", {
                          href: "#",
                          class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1",
                          type: "button",
                          "data-bs-toggle": "modal",
                          "data-bs-target": "#kt_modal_1",
                          onClick: _withModifiers(($event: any) => (_ctx.sendInfo(_ctx.propertyAgeConfig['1'][index], 2)), ["prevent"])
                        }, [
                          _createElementVNode("span", _hoisted_90, [
                            _createVNode(_component_inline_svg, { src: "/media/icons/duotune/art/art005.svg" })
                          ])
                        ], 8, _hoisted_89)
                      ]),
                      _createElementVNode("td", _hoisted_91, _toDisplayString(_ctx.propertyAgeConfig['2'][index].decreasedPercentage + ' %'), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.propertyAgeConfig['2'][index].value), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.propertyAgeConfig['2'][index].priceRentalPerMeter), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("a", {
                          href: "#",
                          class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1",
                          type: "button",
                          "data-bs-toggle": "modal",
                          "data-bs-target": "#kt_modal_1",
                          onClick: _withModifiers(($event: any) => (_ctx.sendInfo(_ctx.propertyAgeConfig['2'][index], 2)), ["prevent"])
                        }, [
                          _createElementVNode("span", _hoisted_93, [
                            _createVNode(_component_inline_svg, { src: "/media/icons/duotune/art/art005.svg" })
                          ])
                        ], 8, _hoisted_92)
                      ]),
                      _createElementVNode("td", _hoisted_94, _toDisplayString(_ctx.propertyAgeConfig['3'][index].decreasedPercentage + ' %'), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.propertyAgeConfig['3'][index].value), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.propertyAgeConfig['3'][index].priceRentalPerMeter), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("a", {
                          href: "#",
                          class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1",
                          type: "button",
                          "data-bs-toggle": "modal",
                          "data-bs-target": "#kt_modal_1",
                          onClick: _withModifiers(($event: any) => (_ctx.sendInfo(_ctx.propertyAgeConfig['3'][index], 2)), ["prevent"])
                        }, [
                          _createElementVNode("span", _hoisted_96, [
                            _createVNode(_component_inline_svg, { src: "/media/icons/duotune/art/art005.svg" })
                          ])
                        ], 8, _hoisted_95)
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.can('update', 'instant-rent-estimator'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
          _createElementVNode("div", _hoisted_98, [
            _createElementVNode("div", _hoisted_99, [
              _createElementVNode("h3", _hoisted_100, _toDisplayString(_ctx.translate('shopRentConfig')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_101, [
            _createElementVNode("div", _hoisted_102, [
              _createElementVNode("div", _hoisted_103, [
                _createElementVNode("div", _hoisted_104, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shopLocationConfig, (item, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                      _createElementVNode("div", _hoisted_105, [
                        _createElementVNode("div", _hoisted_106, [
                          _createElementVNode("div", {
                            class: "d-flex align-items-center collapsible rotate collapsed",
                            href: `#kt_shop_config${index}`,
                            "aria-controls": `kt_shop_config${index}`,
                            "data-bs-toggle": "collapse",
                            role: "button",
                            "aria-expanded": "false"
                          }, [
                            _createElementVNode("div", _hoisted_108, [
                              _createElementVNode("span", _hoisted_109, [
                                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr071.svg" })
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_110, [
                              _createElementVNode("div", _hoisted_111, [
                                _createElementVNode("div", _hoisted_112, _toDisplayString(item.locationsTitle), 1)
                              ])
                            ])
                          ], 8, _hoisted_107)
                        ]),
                        _createElementVNode("div", {
                          id: `kt_shop_config${index}`,
                          class: "fs-6 ps-10 collapse show",
                          "data-bs-parent": "#kt_shop_config",
                          style: {}
                        }, [
                          _createElementVNode("div", _hoisted_114, [
                            _createElementVNode("div", _hoisted_115, [
                              _createElementVNode("table", _hoisted_116, [
                                _createElementVNode("tbody", null, [
                                  _createElementVNode("tr", null, [
                                    _createElementVNode("td", _hoisted_117, _toDisplayString(_ctx.translate('pricepermeter')), 1),
                                    _createElementVNode("td", null, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "number",
                                        autocomplete: "off",
                                        class: "form-control form-control-sm form-control-solid",
                                        placeholder: _ctx.translate('pricepermeter'),
                                        "onUpdate:modelValue": ($event: any) => ((item.pricepermeter) = $event)
                                      }, null, 8, _hoisted_118), [
                                        [_vModelText, item.pricepermeter]
                                      ])
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ], 8, _hoisted_113)
                      ]),
                      _hoisted_119
                    ], 64))
                  }), 128))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_120, [
              _createElementVNode("button", {
                type: "reset",
                class: "btn btn-white btn-active-light-primary me-2",
                onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
              }, _toDisplayString(_ctx.translate('discard')), 1),
              (_ctx.showSaveButtonShop)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    id: "kt_shop_rent_config_submit",
                    ref: "submitShopPricesButton",
                    class: "btn btn-primary",
                    onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.onSubmitShopConfig && _ctx.onSubmitShopConfig(...args)))
                  }, [
                    _createElementVNode("span", _hoisted_121, _toDisplayString(_ctx.translate('saveChanges')), 1),
                    _createElementVNode("span", _hoisted_122, [
                      _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                      _hoisted_123
                    ])
                  ], 512))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.can('update', 'instant-rent-estimator'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_124, [
          _createElementVNode("div", _hoisted_125, [
            _createElementVNode("div", _hoisted_126, [
              _createElementVNode("h3", _hoisted_127, _toDisplayString(_ctx.translate('BasementRentConfig')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_128, [
            _createElementVNode("div", _hoisted_129, [
              _createElementVNode("div", _hoisted_130, [
                _createElementVNode("div", _hoisted_131, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.basementLocationConfig, (item, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                      _createElementVNode("div", _hoisted_132, [
                        _createElementVNode("div", _hoisted_133, [
                          _createElementVNode("div", {
                            class: "d-flex align-items-center collapsible rotate collapsed",
                            href: `#kt_basement_config${index}`,
                            "aria-controls": `kt_basement_config${index}`,
                            "data-bs-toggle": "collapse",
                            role: "button",
                            "aria-expanded": "false"
                          }, [
                            _createElementVNode("div", _hoisted_135, [
                              _createElementVNode("span", _hoisted_136, [
                                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr071.svg" })
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_137, [
                              _createElementVNode("div", _hoisted_138, [
                                _createElementVNode("div", _hoisted_139, _toDisplayString(item.locationsTitle), 1)
                              ])
                            ])
                          ], 8, _hoisted_134)
                        ]),
                        _createElementVNode("div", {
                          id: `kt_basement_config${index}`,
                          class: "fs-6 ps-10 collapse show",
                          "data-bs-parent": "#kt_basement_config",
                          style: {}
                        }, [
                          _createElementVNode("div", _hoisted_141, [
                            _createElementVNode("div", _hoisted_142, [
                              _createElementVNode("table", _hoisted_143, [
                                _createElementVNode("tbody", null, [
                                  _createElementVNode("tr", null, [
                                    _createElementVNode("td", _hoisted_144, _toDisplayString(_ctx.translate('pricepermeter')), 1),
                                    _createElementVNode("td", null, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "number",
                                        autocomplete: "off",
                                        class: "form-control form-control-sm form-control-solid",
                                        placeholder: _ctx.translate('pricepermeter'),
                                        "onUpdate:modelValue": ($event: any) => ((item.pricepermeter) = $event)
                                      }, null, 8, _hoisted_145), [
                                        [_vModelText, item.pricepermeter]
                                      ])
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ], 8, _hoisted_140)
                      ]),
                      _hoisted_146
                    ], 64))
                  }), 128))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_147, [
              _createElementVNode("button", {
                type: "reset",
                class: "btn btn-white btn-active-light-primary me-2",
                onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
              }, _toDisplayString(_ctx.translate('discard')), 1),
              (_ctx.showSaveButtonBasement)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    id: "kt_basement_rent_config_submit",
                    ref: "submitBasementPricesButton",
                    class: "btn btn-primary",
                    onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.onSubmitBasementConfig && _ctx.onSubmitBasementConfig(...args)))
                  }, [
                    _createElementVNode("span", _hoisted_148, _toDisplayString(_ctx.translate('saveChanges')), 1),
                    _createElementVNode("span", _hoisted_149, [
                      _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                      _hoisted_150
                    ])
                  ], 512))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_151, [
      _createElementVNode("div", _hoisted_152, [
        _createElementVNode("div", _hoisted_153, [
          _createElementVNode("div", _hoisted_154, [
            _createElementVNode("h5", _hoisted_155, _toDisplayString(_ctx.translate('editValConfig')), 1),
            _hoisted_156
          ]),
          _createElementVNode("div", _hoisted_157, [
            _createElementVNode("div", _hoisted_158, [
              _createElementVNode("label", _hoisted_159, _toDisplayString(_ctx.translate('value')), 1),
              _createVNode(_component_Field, {
                modelValue: _ctx.selectedDataConfig['value'],
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.selectedDataConfig['value']) = $event)),
                type: "number",
                autocomplete: "off",
                class: "form-control form-control-solid",
                placeholder: _ctx.translate('value'),
                name: `field_value`
              }, null, 8, ["modelValue", "placeholder"]),
              _createElementVNode("div", _hoisted_160, [
                _createElementVNode("div", _hoisted_161, [
                  _createVNode(_component_ErrorMessage, { name: `field_value` })
                ])
              ])
            ]),
            (_ctx.selectedDataConfig['decreasedPercentage'])
              ? (_openBlock(), _createElementBlock("div", _hoisted_162, [
                  _createElementVNode("label", _hoisted_163, _toDisplayString(_ctx.translate('decreasedPercentage')), 1),
                  _createVNode(_component_Field, {
                    modelValue: _ctx.selectedDataConfig['decreasedPercentage'],
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.selectedDataConfig['decreasedPercentage']) = $event)),
                    type: "number",
                    autocomplete: "off",
                    class: "form-control form-control-solid",
                    placeholder: _ctx.translate('decreasedPercentage'),
                    name: `field_decreasedPercentage`
                  }, null, 8, ["modelValue", "placeholder"]),
                  _createElementVNode("div", _hoisted_164, [
                    _createElementVNode("div", _hoisted_165, [
                      _createVNode(_component_ErrorMessage, { name: `field_decreasedPercentage` })
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.selectedDataConfig['increasePercentage'])
              ? (_openBlock(), _createElementBlock("div", _hoisted_166, [
                  _createElementVNode("label", _hoisted_167, _toDisplayString(_ctx.translate('increasePercentage')), 1),
                  _createVNode(_component_Field, {
                    modelValue: _ctx.selectedDataConfig['increasePercentage'],
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.selectedDataConfig['increasePercentage']) = $event)),
                    type: "number",
                    autocomplete: "off",
                    class: "form-control form-control-solid",
                    placeholder: _ctx.translate('increasePercentage'),
                    name: `field_increasePercentage`
                  }, null, 8, ["modelValue", "placeholder"]),
                  _createElementVNode("div", _hoisted_168, [
                    _createElementVNode("div", _hoisted_169, [
                      _createVNode(_component_ErrorMessage, { name: `field_increasePercentage` })
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_170, [
            _hoisted_171,
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[18] || (_cache[18] = _withModifiers(($event: any) => (_ctx.onSubmitDataConfig(_ctx.selectedDataConfig)), ["prevent"])),
              class: "btn btn-primary"
            }, " Save changes ")
          ])
        ])
      ])
    ])
  ], 64))
}